export default "__VITE_ASSET__kVC0V59z__"